<div class="banner-container">
  <div class="sign-up-header" role="img" aria-hidden="true" >
  </div>
</div>
